import React, { FC, SVGProps } from 'react';

export const ElipseWithBorder: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6" cy="6" r="4.5" stroke="#919393" strokeWidth="3" />
  </svg>
);
